import baustein from "baustein";
import carouselMixin from "./mixins/carousel-mixin";


const componentName = "related-from-retailer";

export default baustein.register(componentName, {
    componentName,
    mixins: [carouselMixin],
});
